/**
 * Build an absolute TAG Operations wiki URL from a registry slug (PRO-0480).
 * Returns an empty string when `VITE_WIKI_BASE_URL` is unset so callers omit the link.
 */
export function wikiUrl(wikiPath: string): string {
  const base = (import.meta.env.VITE_WIKI_BASE_URL ?? '').replace(/\/$/, '');
  if (!base) {
    return '';
  }
  const slug = wikiPath.replace(/^\//, '').replace(/\/$/, '');
  return `${base}/${slug}/`;
}
